// PropertyPickerVisual — bundles the empty-state hint (shown only when
// no properties have been picked yet) together with the visual
// PropertyCarousel. Keeps the widget file agnostic of which UI is
// used for property selection: one component, always mounted, whether
// or not the enquiry already has properties.

import React from "react";
import PropertyCarousel from "@/components/booking/PropertyCarousel";
import { COPY } from "@/components/booking/homeBookingWidgetCopy";

const pick = (obj, lang) => {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || obj.fr || "";
};

const PropertyPickerVisual = ({
  blocks,
  selectedSlugs,
  onToggle,
  onEditCamp,
  onOpenLocationModal,
  lang,
  emptyHint,
}) => {
  const isEmpty = !blocks || blocks.length === 0;
  return (
    <div className="mt-5 space-y-4" data-testid="home-booking-property-picker-visual">
      {isEmpty ? (
        <div
          className="border border-dashed border-[#2C2621]/20 bg-white/60 p-6 md:p-8 text-center"
          data-testid="home-booking-empty"
        >
          <p className="text-sm text-[#5C5248] leading-relaxed max-w-2xl mx-auto">
            {emptyHint || pick(COPY.empty, lang)}
          </p>
        </div>
      ) : null}

      {/* Visual property picker — synced with the dropdown above.
          Clicking a card toggles the same block state, so ticking a
          card also appears as checked in the dropdown list, and
          removing a block from the dropdown also unticks the card. */}
      <PropertyCarousel
        blocks={blocks}
        selectedSlugs={selectedSlugs}
        onToggle={onToggle}
        onEditCamp={onEditCamp}
        onOpenLocationModal={onOpenLocationModal}
        lang={lang}
      />
    </div>
  );
};

export default PropertyPickerVisual;
